import { render, staticRenderFns } from "./RaceNumberEdit.vue?vue&type=template&id=5bb7fd30&scoped=true&"
import script from "./RaceNumberEdit.vue?vue&type=script&lang=js&"
export * from "./RaceNumberEdit.vue?vue&type=script&lang=js&"
import style0 from "./RaceNumberEdit.vue?vue&type=style&index=0&id=5bb7fd30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7fd30",
  null
  
)

export default component.exports